// extracted by mini-css-extract-plugin
module.exports = {"form":"bonus-rounds_form__2hZqp","editRoles":"bonus-rounds_editRoles__2pYrF","actionButton":"bonus-rounds_actionButton__35IBC","closeAccount":"bonus-rounds_closeAccount__2jjur"};